<template>
    <div>
        <div v-show="!showIframe">
            <div v-if="isAccountLoaded">
                <AIAHeaderText
                    :headerText="headerText"
                    :modalController="modalController"
                    @clickBack="clickBack" />
                <div v-if="isLoaded">
                    <DefaultLayout
                        :lbl="lbl"
                        :locale="localeCode"
                        :isLogin="isLogin"
                        :detailController="detailController"
                        :modalController="modalController"
                        v-if="detailController.type != 16" />
                    <News
                        :lbl="lbl"
                        :locale="localeCode"
                        :detailController="detailController"
                        :modalController="modalController"
                        v-if="detailController.type == 16" />
                </div>
            </div>
            <modal-master :controller="modalController"></modal-master>
        </div>
        <IframeDetail
            v-if="showIframe"
            :url="iframeUrl"
            :headerText="headerText"
            @close="closeIframe" />
    </div>
</template>
<script>
//helper
import Account from '@/helper/AccountHelper.js';
//core
import { CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//layout
import AIAHeaderText from "@/components/Layout/header/AIAHeaderText.vue";
//component
import DefaultLayout from "../component/layout/Default.vue";
import News from "../component/layout/News.vue";
//controller
import { DetailController } from "../controller/DetailController.js";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";
//iframe
import IframeDetail from "../component/detail/IframeDetail.vue";
export default {
    name: "Campaign",
    mixins: [AccountMixin, ErrorApiMixin, LocaleMixin],
    components: {
        //layout
        AIAHeaderText,
        //detail layout
        DefaultLayout,
        News,
        //modal
        ModalMaster,
        //iframe
        IframeDetail
    },
    data: function() {
        return {
            //page
            isActivated: false,
            isLoaded: false,
            isLoading: false,
            //layout
            // headerText: '',
            quota: null,
            //detail
            detailController: new DetailController(),
            isLogin: Account.isLogin(),
            //iframe
            showIframe: false,
            iframeUrl: null,
        };
    },
    computed: {
        ambassadorCatId: function () {
            return this.$store.getters.getAmbassadorCatId;
        },
        deeplinks: function () {
            return this.$store.getters.getDeeplinks || {};
        },
        headerText: function() {
            return this.lbl.detail.reward_detail;
        }
    },
    created: function() {
        this.initialIsFromLanding();
        if (!this.isActivated) {
            // this.headerText = (this.theme == 'mass') ? this.lbl.detail.mass_headline : this.lbl.detail.prestige_headline;
            // this.headerText = this.lbl.detail.reward_detail;

            this.initialModal();
            this.errorHandler.setAlertModal(this.modalController.alertModal);
            this.errorHandler.setNoInternetModal(this.modalController.noInternetModal);
        }
        Account.initial();
    },
    activated: function () {
        this.getAccountInitiated();
        if (this.isActivated) {
            this.isLoaded = false;
            this.isLoading = false;
            this.quota = null;
            
            this.initialCampaign();
        }
    },
    mounted: function () {
        this.showLoading();
    },
    methods: {
        //event
        clickBack: function () {
            // Go back to AIA app using deeplink
            if (this.deeplinks && this.deeplinks.back_to_privilege) {
                window.location.href = this.deeplinks.back_to_privilege;
            } else {
                // Fallback: use window.history.back() if deeplink is not available
                if (window.history.length > 1) {
                    window.history.back();
                }
            }
            
            this.$destroy();
            this.isActivated = false;
        },
        //initial
        accountInitiated: function () {
            this.initialCampaign();
        },
        initialIsFromLanding: function () {
            if (Account.getCacheCustom("isfromlanding") != undefined) {
                var landingCache = Account.getCacheCustom("isfromlanding");

                if (landingCache != null) {
                    Account.removeCacheCustom("isfromlanding");

                    if (landingCache.page == 'wodd') {
                        return;
                    }

                    var backAmount = (landingCache.page == 'interface') ? -3 : -2;
                    history.go(backAmount);
                }
            }
        },
        initialCampaign: function () {
            var campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .setLocale(this.localeCode)
                .create();

            this.detailController.initialCampaign(this.campaignConfig, this.modalController, this.ambassadorCatId);

            this.detailController.cbGetCampaignSuccess.onCallback(this.getCampaignSuccess);
            this.detailController.cbUpdatePoint.onCallback(this.updateUserPoint);
            this.detailController.cbApiResponseError.onCallback(this.detailApiError);
            this.detailController.cbOpenIframe.onCallback(this.openIframeCallback);
        },
        //#region detail controller callback
        getCampaignSuccess: function () {
            this.isLoaded = false;
            this.$nextTick(()=> {
                this.isActivated = true;
                this.isLoaded = true;
            });

            this.hideLoading();
        },
        openIframeCallback: function (url) {
            this.iframeUrl = url;
            this.showIframe = true;
        },
        closeIframe: function () {
            this.showIframe = false;
            this.iframeUrl = null;
        },
        detailApiError: function (err) {
            this.isLoaded = true;
            this.hideLoading();
            console.log('err', err);
            if (err.code == '409' ) {
                let msg = err.message;
                if (msg.indexOf('Maximum Quota') >= 0) {
                    msg = this.lbl.detail.err_409_maximum_quota;
                }
                this.modalController.alertModal
                    .clearModal()
                    .setMsg(msg)
                    .show();
            } else {
                this.errorApi(err, this.errorHandler);
            }
        },
        //modal
        initialModal: function () {
            //basic modal
            var modalFactory = new ModalFactory();
            this.modalController = modalFactory.getModalController();
            this.alertModal = modalFactory.getAlertModal();
            this.confirmModal = modalFactory.getConfirmModal();
            this.loadingModal = modalFactory.getLoadingModal();
            this.noInternetModal = modalFactory.getNoInternetModal();
            this.successModal = modalFactory.getSuccessModal();
            //redeem modal
            this.confirmRedeemModal = modalFactory.getConfirmRedeemModal();
            this.drawDeliveryModal = modalFactory.getDrawDeliveryModal();
            this.redeemSuccessModal = modalFactory.getRedeemSuccessModal();
            this.serialModal = modalFactory.getSerialModal();
        },
        //loading
        showLoading: function () {
            if (this.isLoading) return true;

            this.isLoading = true;
            this.loadingModal.show();

            return false;
        },
        hideLoading: function () {
            this.isLoading = false;
            this.loadingModal.hide();
        }
    }
}
</script>
<style lang="scss">
    @import "./campaigndetail.scss";
</style>

